import { useTheme } from '@ui-kitten/components';

import constants from '../../../Config/constants';

import ModalPrompt from '../../Web/Modal/ModalPrompt/ModalPrompt';

import BookReservationRender from './Render';
import { SheetProps } from './types';

type Props = SheetProps & {
  modalId: string;
};
const BookReservation = ({ modalId, payload }: Props) => {
  const theme = useTheme();

  // NOTE - scrollIntoView is JavaScript method available on web elements
  const _scrollToSelectTime = (selectTimeContainerRef: {
    scrollIntoView: (args?: any) => void;
  }) => {
    // wait a bit to propagate the change of date on state to auto scroll to select time container
    setTimeout(() => {
      selectTimeContainerRef.scrollIntoView({ behavior: 'smooth' });
    }, 250);
  };
  return (
    <ModalPrompt
      id={modalId}
      closeButtonColor={theme['color-info-500']}
      title={payload.storeInfo.name}
      baseWidth={constants.PAGE_MAX_WIDTH / 2} // half of page max width
      hasHeader
      hasHeaderLine
    >
      <BookReservationRender
        {...payload}
        scrollToSelectTime={_scrollToSelectTime}
      />
    </ModalPrompt>
  );
};

export default BookReservation;
